import { EMPTY_SENTINEL_VALUE } from "@/lib/constants";
import { DataTableViewOptions } from "@/app/components/table/DataTableViewOptions";
import { Input } from "@/app/components/ui/input";
import { Flex } from "@radix-ui/themes";
import { Table } from "@tanstack/react-table";
import React, { useContext, useMemo } from "react";
import { CONSIGNOR_TABLE_COLUMN_VISIBILITY_CACHE_KEY } from "./DataTable";
import accessorKeyHeaderRecord from "./data/accessorKeyHeaderRecord";
import { DataTableFacetedFilter } from "../components/table/DataTableFacetedFilter";
import ConsignorGroupContext from "@/lib/context/ConsignorGroupContext";

interface Props<TData> {
  table: Table<TData>;
}

function DataTableToolBar<TData>({ table }: Props<TData>) {
  const { consignorGroups } = useContext(ConsignorGroupContext);
  const options = useMemo(() => consignorGroups?.map((group) => ({
    label: group.name,
    value: group.name,
  })) ?? [], [consignorGroups]);

  return (
    <Flex align="center" gap="2">
      <Input
        placeholder="Search cocodes, names, emails..."
        value={
          (table.getColumn("cocode")?.getFilterValue() as string) ===
            EMPTY_SENTINEL_VALUE
            ? ""
            : (table.getColumn("cocode")?.getFilterValue() as string) ?? ""
        }
        onChange={(event) => {
          table.getColumn("cocode")?.setFilterValue(event.target.value)
          table.setPageIndex(1);

          const params = new URLSearchParams(window.location.search);
          params.set('page', '1');
          window.history.replaceState(null, '', `?${params.toString()}`);
        }}
        className="w-96 bg-white"
      />
      <DataTableViewOptions
        table={table}
        cacheKey={CONSIGNOR_TABLE_COLUMN_VISIBILITY_CACHE_KEY}
        headerMap={accessorKeyHeaderRecord}
      />
      {table.getColumn("consignorGroup_name") && (
        <DataTableFacetedFilter
          column={table.getColumn("consignorGroup_name")}
          title="Filter"
          options={options}
        />
      )}
    </Flex>
  );
}

export default DataTableToolBar;
